export default __webpack_public_path__ + "static/media/0707BLEU.d2088d78.pdf";